import "./News.scss";

import React, { memo, useCallback, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useLocalStorage } from "usehooks-ts";

import { useNewsCount } from "../../hooks/reactQueryHooks/useNews";
import { CustomModal } from "../CustomModal";
import { GiftIcon } from "../icons";
import { NewsContent } from "./NewsContent";

const News: React.FC = memo(() => {
  const [showModal, setShowModal] = useState(false);
  const [internalNewsCount, setInternalNewsCount] = useState<number>(0);

  const [lastVisitTime, setLastVisitTime] = useLocalStorage<number | null>(
    "lastVisitTime",
    null,
  );

  const { data: newsCount } = useNewsCount(
    lastVisitTime ? new Date(lastVisitTime) : null,
  );

  useEffect(() => {
    if (newsCount) {
      setInternalNewsCount(newsCount);
    }
  }, [newsCount]);

  const handleClick = useCallback(() => {
    setShowModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setLastVisitTime(Date.now());
    setInternalNewsCount(0);
    setShowModal(false);
  }, [setLastVisitTime]);

  return (
    <>
      <div data-testid="news" className="news-button-container">
        <Button
          onClick={handleClick}
          variant="outline-light"
          className="no-arrow"
        >
          <GiftIcon />
        </Button>
        {!!internalNewsCount && (
          <div data-testid="count-bubble" className="news-button-badge">
            {internalNewsCount > 9 ? "9+" : internalNewsCount}
          </div>
        )}
      </div>
      {showModal && (
        <CustomModal
          title="What's new"
          show={true}
          handleClose={closeModal}
          footer={
            <Button
              className="btn btn-secondary btn-sm"
              size="sm"
              variant="secondary"
              onClick={closeModal}
            >
              Close
            </Button>
          }
        >
          <NewsContent lastVisitTime={lastVisitTime} />
        </CustomModal>
      )}
    </>
  );
});

export { News };
